export default __webpack_public_path__ + "static/media/skolval-2022 (1).f11cd4b2.pdf";